var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.isTeam)?_c('player-name',{attrs:{"showIdOfPlatform":_vm.showIdOfPlatform,"player":_vm.player}}):_vm._e(),(_vm.isTeam)?_c('team-name',{attrs:{"team":_vm.player}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }